// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4240) return "static/chunks/4240.2fdf5cd41f1b0a22.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6715 ? "85582243" : chunkId) + "-" + {"70":"9e6604a52d2c4227","6715":"b0aa1d34a5a5bd69"}[chunkId] + ".js";
};